import { Component, Input } from '@angular/core';
import { ProdutoPromocional } from '../../../core/models/produtos/produto-promocional';

/**
 * Aviso de itens com pendência de estoque (qtde solicitada > estoque) do Passo 1
 * (pedidos-cadastro.component.html:1193-1227). Read-only.
 *
 * Gate de visibilidade do bloco inteiro (usaPendencia && temItensPendencia()) fica no PAI,
 * envolvendo <app-pedido-itens-pendencia> com @if — não é @Input aqui (mesmo padrão do
 * app-prazo-pagamento-select no Passo 0/Fase 2a).
 */
@Component({
  selector: 'app-pedido-itens-pendencia',
  standalone: false,
  templateUrl: './pedido-itens-pendencia.component.html',
  styleUrls: ['./pedido-itens-pendencia.component.scss']
})
export class PedidoItensPendenciaComponent {
  @Input() produtosAdicionados: ProdutoPromocional[] = [];
}
